exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table {\r\n    text-align: center;\r\n}\r\n.table .bg-danger {\r\n    color: white;\r\n    font-weight: bold;\r\n}\r\n.table .bg-success {\r\n    color: white;\r\n    font-weight: bold;\r\n}\r\n.card-black {\r\n    background-color: black !important;\r\n    color:white;\r\n}\r\ndiv.main-chart {\r\n    width: 100%;\r\n    height:300px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Page/adr-system/adr-system.component.css
// module id = ../../../../../src/app/Page/adr-system/adr-system.component.css
// module chunks = main